__turbopack_context__.v({
  "desktopVideo": "VideoHero-module__ue2hna__desktopVideo",
  "mobileVideo": "VideoHero-module__ue2hna__mobileVideo",
  "subtitle": "VideoHero-module__ue2hna__subtitle",
  "textContainer": "VideoHero-module__ue2hna__textContainer",
  "title": "VideoHero-module__ue2hna__title",
  "videoContainer": "VideoHero-module__ue2hna__videoContainer",
  "videoWrapper": "VideoHero-module__ue2hna__videoWrapper",
});
